export const isObject = (value: unknown): value is object => {
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    typeof value !== 'function'
  );
};

export const hasKey = <T extends object>(
  obj: unknown,
  key: keyof any,
): obj is T => {
  return typeof obj === 'object' && obj !== null && key in obj;
};
